import type { ConnectionsBhSankeyNode } from '@act/shared/data-transfer-objects';
import { useMemo } from 'react';
import { buildBhSankeySvgFromNodes } from './buildBhSankey.util';

export interface BhConnectionsSankeyProps {
  nodes: ConnectionsBhSankeyNode[];
}

/**
 * Renders the behavioral-health connections Sankey diagram from snapshot nodes.
 * @param props - Sankey node values from the warehouse snapshot.
 */
const BhConnectionsSankey = ({ nodes }: BhConnectionsSankeyProps) => {
  const connectedCount =
    nodes.find(node => node.id === 'connected')?.value ?? 0;
  const svgHtml = useMemo(() => buildBhSankeySvgFromNodes(nodes), [nodes]);

  return (
    <div
      className="sankey-wrap"
      role="img"
      aria-label={`Sankey diagram showing flow of ${connectedCount} members connected to behavioral health care`}
      dangerouslySetInnerHTML={{ __html: svgHtml }}
    />
  );
};

export default BhConnectionsSankey;
